import React from 'react';
import { connect } from 'react-redux';
import '../top-mover.scss';
import Financial from './financial';
import Overview from './overview/Overview';
import Performance from './performance';
import Technical from './technical';
import {
  cancelFetchListTopValueTable,
  fetchListTopValueTable,
} from './reducer';
import Chart from './chart/Chart';
import Footer from '../../../common/table/Footer';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class AllExchanges extends AutoReloadOnFocusBlurComponent {
  reload() {
    const { dispatch, filter } = this.props;
    dispatch(fetchListTopValueTable(filter));
  }

  componentDidMount() {
    super.componentDidMount();
    const { dispatch, filter } = this.props;
    dispatch(fetchListTopValueTable(filter));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, filter } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      dispatch(fetchListTopValueTable(filter));
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    const { dispatch } = this.props;
    dispatch(cancelFetchListTopValueTable());
  }

  render() {
    const { typeTab } = this.props;
    return (
      <div className="tab-pane active top-mover-content d-flex flex-fill flex-column">
        {typeTab !== 5 && (
          <div className="d-flex flex-column flex-fill pl-20 pr-20">
            {typeTab === 1 && <Overview />}
            {typeTab === 2 && <Performance />}
            {typeTab === 3 && <Financial />}
            {typeTab === 4 && <Technical />}

            <Footer />
          </div>
        )}

        {typeTab === 5 && <Chart />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(AllExchanges);
